import { render, staticRenderFns } from "./Quantity.vue?vue&type=template&id=664d20a8&scoped=true&"
import script from "./Quantity.vue?vue&type=script&lang=ts&"
export * from "./Quantity.vue?vue&type=script&lang=ts&"
import style0 from "./Quantity.vue?vue&type=style&index=0&id=664d20a8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664d20a8",
  null
  
)

export default component.exports